"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ({
  hasFooter,
  hasHeader,
  hideCloseButton
}) => {
  const scrollingHeaderStyles = hasHeader || !hideCloseButton ? {
    // The following adapted from https://lea.verou.me/2012/04/background-attachment-local/
    background: 'linear-gradient(white 30%, white), linear-gradient(rgb(0 0 0 / 10%) 0%, white)',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
    backgroundSize: '100% 30px, 100% 10px',
    backgroundAttachment: 'local, scroll'
  } : {};
  return {
    borderBottomRadius: hasFooter ? null : 'md',
    paddingX: 4,
    paddingBottom: 4,
    flex: 1,
    overflow: 'auto',
    display: 'flex',
    ...scrollingHeaderStyles
  };
};
exports.default = _default;